<template>
  <b-navbar class="app-toolbar" :class="{'show-toolbar' : pageTitle}">
    <div class="nav-left">
      <b-button v-if="user"
                variant="none"
                class="desktop-sidebar"
                @click="handleMenuSlide('desktop')"
      >
        <img src="../assets/img/icon/sidebar.svg" alt="Toggle Menu">
      </b-button>
      <b-button v-if="user"
                variant="none"
                class="mobile-sidebar"
                @click="handleMenuSlide('mobile')"
      >
        <img src="../assets/img/icon/mobile-sidebar.svg" alt="Toggle Menu">
      </b-button>
      <b-navbar-brand :to="indexPageUrl"
                      :href="guestIndexPageUrl"
                      class="ul-header">
        <img class="ul-logo" src="../assets/img/ul-logo.png" alt="U Lifestyle">
        <span class="ul-title">商戶中心</span>
      </b-navbar-brand>
      <div class="title">
        <span>{{pageTitle}}</span>
      </div>
    </div>
    <div style="flex: 1"></div>
    <div class="nav-right">
      <b-navbar-nav v-if="user" class="ml-auto">
        <template v-if="user.role === 'admin' && currentRouteName === 'ListNotification'" >
          <NotificationButtonAdd v-if="isMobile" />
        </template>
        <template v-if="user.role !== 'sub-merchant'">
          <router-link
            :to="{ name: 'AddCoupon' }"
            v-if="user.class === 'NORMAL'"
          >
            <CouponAddButton
              class="mr-2 ml-2"
              variant="outline-primary"
            ></CouponAddButton>
          </router-link>
          <b-dropdown variant="link" toggle-class="custom-dropdown" no-caret v-else>
            <template #button-content>
              <CouponAddButton
                class="mr-2 ml-2 desktop-button"
                variant="outline-primary"
              ></CouponAddButton>
            </template>
            <b-dropdown-item @click="$router.push({ name: 'AddCoupon'})">
              <img class="mr-2" src="@/assets/img/icon/coupon.svg"/>積分優惠券
            </b-dropdown-item>
            <b-dropdown-item @click="$router.push({ name: 'AddReservationCoupon'})">
              <img class="mr-2" src="@/assets/img/icon/reservation-coupon.svg"/>指定日子優惠券(付費)
            </b-dropdown-item>
            <b-dropdown-item @click="$router.push({ name: 'AddPaymentCoupon'})">
              <img class="mr-2" src="@/assets/img/icon/paid-coupon.svg"/>商品/服務優惠券 (付費)
            </b-dropdown-item>
          </b-dropdown>
          <div class="vl"></div>
        </template>
        <template v-if="user.role !== 'sub-merchant'">
          <div class="mobile-button">
            <b-button v-if="currentRouteName === 'ListCoupons'"
                      @click="$router.push({ name: 'AddCoupon'})"
                      variant="none"
            >
              <img src="../assets/img/icon/mobile-add.svg" alt="add">
            </b-button>
            <b-button v-if="currentRouteName === 'ListPaidCoupons'"
                      @click="$router.push({ name: 'AddPaymentCoupon'})"
                      variant="none"
            >
              <img src="../assets/img/icon/mobile-add.svg" alt="add">
            </b-button>
            <b-button v-if="currentRouteName === 'ListCheckinCoupons'"
                      @click="$router.push({ name: 'AddCheckinCoupon'})"
                      variant="none"
            >
              <img src="../assets/img/icon/mobile-add.svg" alt="add">
            </b-button>
            <b-button v-if="currentRouteName === 'ListReservationCoupons'"
                      @click="$router.push({ name: 'AddReservationCoupon'})"
                      variant="none"
            >
              <img src="../assets/img/icon/mobile-add.svg" alt="add">
            </b-button>
            <b-button v-if="currentRouteName === 'SubMerchant'"
                      v-b-modal.modal-multi-add
                      variant="none"
            >
              <img src="../assets/img/icon/mobile-add.svg" alt="add">
            </b-button>
          </div>
        </template>
        <template v-if="user.role === 'sub-merchant'">
          <div class="mobile-button">
            <b-button v-if="currentRouteName === 'ListQrCode'
                      || currentRouteName === 'ListScannedCoupons'
                      || currentRouteName === 'ListReservations'
                      || currentRouteName === 'TransactionOverview'"
                      @click="$router.push({ name: 'Scan'})"
                      variant="none"
            >
              <img src="../assets/img/icon/scan-active.svg" alt="add">
            </b-button>
          </div>
        </template>
        <b-nav-item-dropdown right>
          <template v-slot:button-content>
            <div class="user-info">
              <img v-if="userInfo.avatar"
                  class="user-info__avatar"
                  :src="userInfo.avatar | imagePath('merchantLogo', 'thumbnail', false)"
                  :alt="userInfo.title"
              >
              <div>
                <span class="user-info__title"
                      :class="{'showTitle' : currentRouteName === 'Home'}">
                  {{ userInfo.title }}
                </span>
                <span class="user-info__subtitle">
                  {{ userInfo.subtitle }}
                </span>
              </div>
            </div>
          </template>
          <b-dropdown-item
          v-if="user.role === 'merchant'"
          @click="$router.push('/setting')">
          帳戶設定
          </b-dropdown-item>
          <b-dropdown-item v-if="role ==='sub-merchant'" v-stream:click="onLogoutSubMerchant$">
            登出
          </b-dropdown-item>
          <b-dropdown-item v-else v-stream:click="onLogout$">
            登出
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
  </b-navbar>
</template>

<script>
import { mapState } from 'vuex';
import {
  BButton,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdown,
} from 'bootstrap-vue';
import CouponAddButton from './coupon/CouponAddButton.vue';
import NotificationButtonAdd from './notification/NotificationButtonAdd.vue';
import isMobileMixin from '../mixins/is-mobile';
import logoutMixin from '../mixins/logout';
import imagePath from '../filters/image-path';
import { SET_MENU, SET_MOBILE_MENU, SET_USER } from '../store/index';

export default {
  mixins: [isMobileMixin, logoutMixin],
  components: {
    'b-button': BButton,
    'b-navbar': BNavbar,
    'b-navbar-brand': BNavbarBrand,
    'b-navbar-nav': BNavbarNav,
    'b-nav-item-dropdown': BNavItemDropdown,
    'b-dropdown-item': BDropdownItem,
    BDropdown,
    CouponAddButton,
    NotificationButtonAdd,
  },
  computed: {
    ...mapState(['user']),
    ...mapState(['isMobileMenu']),
    userInfo() {
      if (this.user.role === 'admin') {
        return {
          title: 'Admin',
          subtitle: this.user.username,
          avatar: null,
        };
      }
      if (this.user.role === 'sale') {
        return {
          title: 'Sale',
          subtitle: this.user.username,
          avatar: null,
        };
      }
      return {
        title: this.user.name,
        subtitle: this.user.username,
        avatar: this.user.logo,
      };
    },
    indexPageUrl() {
      if (!this.user) return null;
      if (this.user.role === 'admin') return '/admin';
      if (this.user.role === 'sale') return '/sale';
      if (this.user.role === 'sub-merchant') return '/qr-scanner';
      return '/';
    },
    guestIndexPageUrl() {
      if (this.user) return null;
      const utmTracking = 'utm_source=url&utm_medium=website&utm_campaign=ul_merchantcenter&utm_content=ul';
      return `/merchantcenter/recruit/index.html?${utmTracking}`;
    },
    currentRouteName() {
      return this.$route.name;
    },
    pageTitle() {
      let title;
      switch (this.currentRouteName) {
        case 'Home':
          title = '主頁';
          break;
        case 'ListCoupons':
          title = '積分優惠券';
          break;
        case 'ListPaidCoupons':
          title = '商品/服務優惠券';
          break;
        case 'ListCheckinCoupons':
          title = '打卡優惠券';
          break;
        case 'ListReservationCoupons':
          title = '指定日子優惠券';
          break;
        case 'ListSalesOrder':
          title = '銷售訂單';
          break;
        case 'ListRecords':
          title = '收款狀態';
          break;
        case 'ListMerchants':
          title = '商戶';
          break;
        case 'ListSales':
          title = '營銷人員 ';
          break;
        case 'ListReports':
          title = '統計報告';
          break;
        case 'ListNotification':
          title = '最新消息';
          break;
        case 'Community':
          title = 'U Lifestyle 社群';
          break;
        case 'ListCompanyIntroTemplate':
          title = '公司簡介範本';
          break;
        case 'FAQ':
          title = '常見問題';
          break;
        case 'Setting':
          title = '帳戶設定';
          break;
        // case 'MerchantLogin':
        //   title = '商戶登入';
        //   break;
        // case 'AdminLogin':
        //   title = '管理員登入';
        //   break;
        case 'SubMerchant':
          title = '管理附屬帳戶';
          break;
        case 'ListQrCode':
          title = '現時可兌換優惠';
          break;
        case 'ListScannedCoupons':
          title = '使用紀錄';
          break;
        case 'ListReservations':
          title = '訂座紀錄';
          break;
        case 'TransactionOverview':
          title = '交易紀錄';
          break;
        case 'ListCreatorCampaigns':
          title = '活動申請';
          break;
        default:
          title = '';
          break;
      }
      return title;
    },
    isLoginPage() {
      return this.$route.name === 'MerchantLogin' || 'AdminLogin';
    },
  },
  filters: {
    imagePath,
  },
  methods: {
    handleMenuSlide(device) {
      if (device === 'desktop') {
        this.$store.commit(SET_MENU);
      }
      this.$store.commit(SET_MOBILE_MENU);
    },
    logoutSubMerchant() {
      localStorage.clear();
      this.$store.commit(SET_USER, null);
      this.$router.push({ name: 'SubMerchantLogin' });
    },
  },
};
</script>

<style scoped lang="scss">
.navbar-brand {
    display: inline-block;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap;
    align-items: center;
    padding: 12px 0px 14px 0px;

  & img {
    height: 28px;
  }

  & span {
    margin-left: 15px;
    font-size: 1rem;
    font-weight: 500;
    color: #333132;
  }
}

.app-toolbar {
  position: fixed;
  width: 100%;
  top: 0;
  padding: 0.25rem 1rem;
  box-shadow: 0px 1px 0px #EBEEF0;
  background: white;
  z-index: 100;
  display: flex;

  @include respond(tab-landscape) {
    display: none;
    flex-direction: row;
    padding: 0.25rem 0.5rem;
    height: 3rem;
  }

  .nav-left {
    @include respond(tab-landscape) {
      .ul-header {
        display: none;
      }
    }

    .desktop-sidebar {
      display: inline-block;
      padding: 0px 8px;
      box-sizing: border-box;
      margin-right: 16px;
      width: 40px;
      position: relative;
      top: -5px;

      @include respond(tab-landscape) {
        display: none;
      }
    }

    .mobile-sidebar{
      display: none;
      margin-right: 0px;

      @include respond(tab-landscape) {
        display:inline-block;
        padding:0px 8px;
        box-sizing: border-box;
        margin-right:16px;
        width:40px;
        position: relative;
        top:-5px;
      }
    }

    .title {
      color: #174169;
      font-weight: 500;
      font-size: 20px;
      display: none;
      box-sizing: border-box;
      @include respond(tab-landscape) {
        display: inline-block;
        font-size: 18px;
      }
    }
  }

  .nav-right {
    display:flex;

    .desktop-button {
      @include respond(phone) {
        display: none;
      }
    }

    .mobile-button {
      display: none;
      @include respond(phone) {
        display: inline-block;
        .btn {
          padding: 5px;
        }
      }
    }

    &::v-deep {
      .btn {
        font-size: 14px;
      }
      .btn-outline-primary{
        color: #3596F4;

        &:hover {
          background: rgba(0, 132, 255, 0.2);
          color: #fff;
          background-color: #3596f4;
          border-color: #3596f4;
        }
      }
      .custom-dropdown {
        text-decoration: none!important;
        padding: 0;
        margin:0;
      }
    }
  }

  & .ul-logo {
    width:108px;
  }

  & .ul-title{
    color: #333132 ;
    font-weight: 400;
    margin-left: 10px;
    position: relative;
    top: 3px;
    font-weight: 500;
  }

  &::v-deep {
    & .navbar-nav {
      align-items: center;
      flex-direction: row;
    }

    & .nav-link {
      display: flex;
      align-items: center;
    }
  }
}

.show-toolbar {
  display: flex;
}

.vl {
    border-left: 1px solid #DDE1E5;
    border-radius: 10px;
    height: 24px;
    margin-left: 2px;
    margin-right: 12px;

    @include respond(tab-landscape) {
      display: none;
    }
}

.user-info {
  display: flex;
  align-items: center;
  margin-right: 12px;

  @include respond(tab-landscape) {
    margin-right: 0px;
    flex-direction: row-reverse;
  }

  &__avatar {
    margin-right: 8px;
    width: 36px;
    height: 36px;
    object-fit: contain;
    border-radius: 50%;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }

  &__title {
    color: #3a4047;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;

    @include respond(tab-landscape) {
      font-size: 14px;
      margin-right: 10px;
      display: none;
    }
  }

  &__subtitle {
    color: #7e8b97;
    font-size: 13px;
    line-height: 17px;

    @include respond(tab-landscape) {
      display: none;
    }
  }

  .showTitle {
    display: inline-block;
  }
}
</style>
